import React from 'react';

import DiscussionFormModal from '../components/DiscussionFormModal';
import ExternalLink from '../components/ExternalLink';
import FormatText from '../components/FormatText';
import Paragraph from '../components/Paragraph';
import PostImages from '../components/PostImages';
import PostPage, { PostPageProps } from '../components/PostPage';
import useOpener from '../hooks/useOpener';
import { toUrl } from '../services/urlUtils';
import { JSONApi, Models } from '../types';

type Props = {
  discussion: JSONApi.DiscussionResource;
  group: JSONApi.GroupResource;
};

const DiscussionPage = ({ discussion, group }: Props) => {
  const { description, link } = discussion.attributes;

  const modalOpener = useOpener();

  const url = toUrl(link);

  const postPageProps: PostPageProps<Models.Discussion> = {
    backHref: `/g/${group.attributes.slug}/forum`,
    group,
    post: discussion
  };

  if (discussion.attributes.permissions.edit) {
    postPageProps.onEditClick = modalOpener.toggle;
  }

  return (
    <PostPage<Models.Discussion> {...postPageProps}>
      <DiscussionFormModal
        discussion={discussion}
        group={group}
        opener={modalOpener}
        titleKey="modals.editDiscussion.title"
      />
      {description && (
        <div className="ion-padding-bottom ion-padding-end ion-padding-start">
          <Paragraph className="formatted-text">
            <FormatText autolink mentionable>
              {description}
            </FormatText>
          </Paragraph>
          {url && (
            <Paragraph>
              <ExternalLink href={url.toString()}>{url.host}</ExternalLink>
            </Paragraph>
          )}
        </div>
      )}
      <PostImages post={discussion} />
    </PostPage>
  );
};

export default DiscussionPage;
